/**
 * Dark theme — Roomgrid design system.
 * All tokens and overrides live in ./roomgrid.ts (shared with lightTheme).
 */

import { buildRoomgridTheme } from "./roomgrid";

export const darkTheme = buildRoomgridTheme("dark");

export default darkTheme;
